
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V8H3V4ZM7 10V22H5C3.89543 22 3 21.1046 3 20V10H7ZM21 10H9V22H13.3163C12.4925 20.9727 11.9998 19.6685 11.9998 18.2493C11.9998 14.9356 14.686 12.2493 17.9998 12.2493C19.0927 12.2493 20.1174 12.5415 21 13.0521V10ZM14 18.4115C14.7581 16.9773 16.2649 16 18 16C19.7351 16 21.2419 16.9773 22 18.4115C21.2419 19.8456 19.7351 20.8229 18 20.8229C16.2649 20.8229 14.7581 19.8456 14 18.4115ZM19.2059 18.4115C19.2059 19.0774 18.6661 19.6172 18.0002 19.6172C17.3343 19.6172 16.7945 19.0774 16.7945 18.4115C16.7945 17.7456 17.3343 17.2057 18.0002 17.2057C18.6661 17.2057 19.2059 17.7456 19.2059 18.4115Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowTemplatePreviewFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
